import React from 'react';

export default function About() {
  return (
    <div className="about-page" style={{
      maxWidth: '900px',
      margin: '20px auto',
      background: '#ffffff',
      borderRadius: '12px',
      padding: '24px',
      boxShadow: '0 2px 12px rgba(0,0,0,0.08)'
    }}>
      <h1 style={{ marginTop: 0 }}>About Shopie Bazar</h1>

      <p>
        Shopie Bazar is an e‑commerce store offering quality products at competitive prices across India.
        We focus on a seamless, secure, and delightful shopping experience for our customers.
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24, alignItems: 'start' }}>
        <div>
          <h3>Our Mission</h3>
          <p>
            To empower small and medium businesses to reach customers nationwide while giving shoppers
            a wide selection, fast delivery, and great value.
          </p>

          <h3>What We Offer</h3>
          <ul style={{ paddingLeft: 18, marginTop: 8 }}>
            <li>Curated catalog across multiple categories</li>
            <li>Secure payments and buyer protection</li>
            <li>Easy returns and responsive support</li>
          </ul>

          <h3>Trust & Safety</h3>
          <p>
            We are committed to privacy, data security, and fair marketplace practices. Learn more in our
            <a href="/privacy" style={{ marginLeft: 6 }}>Privacy Policy</a> and
            <a href="/terms" style={{ marginLeft: 6 }}>Terms of Use</a>.
          </p>
        </div>

        <div>
          <h3>Company</h3>
          <p style={{ margin: 0 }}><strong>SHOPIE TECHNOLOGIES PVT. LTD.</strong></p>

          <h3 style={{ marginTop: 16 }}>Address</h3>
          <p style={{ margin: 0 }}>
            A 19, Ground Floor FIEE Complex,<br/>
            Okhla Phase II, Okhla Industrial Estate,<br/>
            New Delhi, India - 110020
          </p>

          <h3 style={{ marginTop: 16 }}>Contact</h3>
          <p style={{ margin: 0 }}>
            Phone: <a href="tel:+911169266020">+91 1169266020</a><br/>
            Email: <a href="mailto:support@shopiebazar.com">support@shopiebazar.com</a>
          </p>

          {/* Seller/marketplace features are currently disabled */}
        </div>
      </div>

      <div style={{ marginTop: 24, padding: '16px', background: '#f9fafb', borderRadius: 8 }}>
        <h3 style={{ marginTop: 0 }}>Customer Support</h3>
        <p style={{ margin: 0 }}>
          Need help? Visit our <a href="/help">Help Center</a>, check <a href="/returns-refunds">Returns & Refunds</a>,
          or <a href="/contact">Contact Us</a>.
        </p>
      </div>
    </div>
  );
}
